import { useState } from 'react'
import dayjs from 'dayjs'
import { Work } from '@/javascript/domain/entities/work'

const useRoutingWorks = () => {
  const [selectedWorks, setSelectedWorks] = useState<Work[]>([])
  const [workDurations, setWorkDurations] = useState<Record<string, dayjs.Dayjs>>({})
  const [durationErrors, setDurationErrors] = useState<Record<string, string | null>>({})

  return {
    selectedWorks, setSelectedWorks,
    workDurations, setWorkDurations,
    durationErrors, setDurationErrors,
  }
}

export default useRoutingWorks
